module.exports = __webpack_public_path__ + "img/icon_ticket_used.e62b4a89.png";